export default {"src":"/_next/static/media/youtube-color-icon.8be7eedd.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};